import { useAppDispatch } from '@features';
import { TableCell, TableRow } from '@repo/shadcn';
import { FC } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { DatePickerField, TextField } from '@components/form/fields';
import { DeleteButton } from '@components/ui/button';

import { removeExpiryAdjustmentItem } from '@/features/slice/inventory';

import { TCreateExpiredStockAdjustment } from './schema';

//
type CreatePurchaseItemProps = {
    item: TCreateExpiredStockAdjustment['items'][number];
    serialNumber: number;
};

export const ExpiryRestockItem: FC<CreatePurchaseItemProps> = ({
    item,
    serialNumber,
}) => {
    const { control } = useFormContext<TCreateExpiredStockAdjustment>();

    const dispatch = useAppDispatch();

    const { remove } = useFieldArray({
        control,
        name: 'items',
    });

    const handleRemoveItem = () => {
        remove(serialNumber - 1);
        dispatch(removeExpiryAdjustmentItem(item.purchaseItemId));
    };

    const renderExpirationDate = () => {
        // return format(item.expirationDate ?? '', 'dd/MM/yyyy');
        return (
            // <DateInputField<TCreateExpiredStockAdjustment>
            //     name={`items.${serialNumber - 1}.expirationDate` as const}
            //     // inputClass={'w-32'}
            // />
            <DatePickerField<TCreateExpiredStockAdjustment>
                name={`items.${serialNumber - 1}.expirationDate` as const}
                // inputClass={'w-32'}
                disableCalendar
            />
        );
    };

    const renderQuantity = () => {
        return (
            <TextField<TCreateExpiredStockAdjustment>
                inputClass={'w-20 text-right'}
                name={`items.${serialNumber - 1}.quantity` as const}
            />
        );

        // return item.quantity;
    };

    const renderPurchasePrice = () => {
        return (
            <TextField<TCreateExpiredStockAdjustment>
                name={`items.${serialNumber - 1}.updatedPurchasePrice` as const}
                inputClass={'w-28 text-right'}
            />
        );
    };

    const renderWholesalePrice = () => {
        return (
            <TextField<TCreateExpiredStockAdjustment>
                name={`items.${serialNumber - 1}.wholesalePrice` as const}
                inputClass={'w-28 text-right'}
            />
        );
    };

    const renderRetailPrice = () => {
        return (
            <TextField<TCreateExpiredStockAdjustment>
                name={`items.${serialNumber - 1}.retailPrice` as const}
                inputClass={'w-28 text-right'}
            />
        );
    };

    // const renderTotalPrice = () => {
    //     return formatCurrencyInBDT(item.purchase_price * item.quantity);
    // };

    return (
        <TableRow className={'rounded-md even:bg-white/70'}>
            <TableCell className="p-2 font-medium">{serialNumber}</TableCell>
            <TableCell>{item.productName}</TableCell>
            <TableCell>{renderExpirationDate()}</TableCell>
            <TableCell className={'flex justify-end text-right'}>
                {renderQuantity()}
            </TableCell>
            <TableCell className="tflex ext-right justify-end">
                {renderPurchasePrice()}
            </TableCell>
            <TableCell className="tflex ext-right justify-end">
                {renderWholesalePrice()}
            </TableCell>

            <TableCell className="tflex ext-right justify-end">
                {renderRetailPrice()}
            </TableCell>
            <TableCell className="flex justify-end text-right">
                <DeleteButton isIconButton={true} onClick={handleRemoveItem} />
            </TableCell>
        </TableRow>
    );
};

ExpiryRestockItem.displayName = 'CreatePurchaseItem';
